// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import inject from './inject'


// vuex stored
import store from './store'
import service from '@/service'
import http from '@/http'
import util from '@/util/util'
import VueConf from './VueConf'
import './assets/fonts/iconfont.css'

//
import App from './App'
import router from './router'
// import htmlToPdf from '@/components/util/htmlToPdf'
// Vue.use(htmlToPdf)
// import Blob from './excel/Blob.js'
// import Export2Excel from './excel/Export2Excel.js'

//引入 Element
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

//全局引入ECharts
import shine from './assets/json/shine.json';
import * as echarts from 'echarts';
echarts.registerTheme('shine', shine)
Vue.prototype.$echarts = echarts

// 导入js文件
import config from './common/config'
// 挂载
Vue.prototype.$device = config

// 全局引入Moment.js
import moment from 'moment'
Vue.prototype.$moment = moment
Vue.filter('dateFormat', function(dataStr, pattern = 'YYYY-MM-DD HH:mm:ss') {
  if (dataStr !== undefined) {
    return moment(dataStr).format(pattern)
  }
})

Vue.filter('numFilter', function(number) {
  if(value != null) {
    let bite = 0;
    if(number < 10){
      return 10;
    }
    while( number >= 10 ){
      number /= 10;
      bite += 1;
    }
  }
  return Math.ceil(number) * Math.pow(10,bite);
})

Vue.use(inject)
Vue.use(ElementUI);
Vue.use(VueConf, {
  ElementUI
})


Vue.prototype.$service = service;
Vue.prototype.$http = http;
Vue.prototype.$util = util;

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})





// WEBPACK FOOTER //
// ./src/main.js